import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AxiosError } from 'axios'

import { axiosInstance } from '../lib/api_client'

type Props = Readonly<{
  listingId?: number
  mercariProductId?: string | null
  mercariDelistedAt?: string | null
  active: boolean
}>

const MercariListingActions = ({ listingId, mercariProductId, mercariDelistedAt, active }: Props) => {
  const { t } = useTranslation()
  const [busy, setBusy] = useState(false)
  const [note, setNote] = useState<string | null>(null)

  const linked = !!mercariProductId
  const delisted = !!mercariDelistedAt
  const canList = active && !!listingId && (!linked || delisted)
  const canDelist = linked && !delisted && !!listingId

  if (!canList && !canDelist) return null

  const post = (path: string) => {
    setBusy(true)
    axiosInstance.post(path)
      .then(() => setNote(t('cards.item.mercari.queued')))
      .catch((error: AxiosError<{ error?: string }>) => {
        setNote(error.response?.data?.error || t('cards.item.mercari.failed'))
      })
      .finally(() => setBusy(false))
  }

  return (
    <div>
      { canList && (
        <p>
          <button
            type="button"
            className="button tool"
            disabled={ busy }
            onClick={ () => post(`/mercari_shops/listings/${listingId}/list`) }
          >
            { t('cards.item.mercari.list') }
          </button>
        </p>
      ) }
      { canDelist && (
        <p>
          <button
            type="button"
            className="tool"
            disabled={ busy }
            onClick={ () => post(`/mercari_shops/listings/${listingId}/delist`) }
          >
            { t('cards.item.mercari.delist') }
          </button>
        </p>
      ) }
      { note && <p>{ note }</p> }
    </div>
  )
}

export { MercariListingActions }
